var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"file-select"},[_c('div',{staticClass:"btn btn-info btn-fill btn-wd"},[(_vm.value)?_c('span',[_vm._v(_vm._s(_vm.value.name))]):_c('span',[_vm._v("Escolher")])]),_c('input',{attrs:{"type":"file","accept":"image/*","capture":"camera"},on:{"change":_vm.handleFileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }